import { SerieDescriptionDto } from "../models/serieDescriptionDto";

export class GraphSerieHelper {
    public static getMinValue(values: any){
        return values.length
        ? Math.min.apply(Math, values)
        : null;
      }
    
      public static getMaxValue(values: any){
        return values.length
        ? Math.max.apply(Math, values)
        : null;
      }
    
      public static getAverageValue(values: any){
        return values.length
        ? values.reduce((a, b) => a + b) / values.length
        : null;
      }
    
      public static extractValues(serie: SerieDescriptionDto, dataSource: any,argumentAxis: any):number[]{
        const values: number[] = [];
        dataSource.forEach((element) => {
          if (
            element[serie.value] !== undefined &&
            element[serie.value] !== null
          ) {
            if (
              new Date(element.TimeStamp) >=
                argumentAxis.visualRange[0] &&
              new Date(element.TimeStamp) <= argumentAxis.visualRange[1]
            ) {
              values.push(element[serie.value]);
            }
          }
        });

        return values;
  }
  }
  